import { LocalStorageService } from './LocalStorageService';

export * from './constants';
// eslint-disable-next-line import/no-cycle
export * from './types';

export const localStorageService = new LocalStorageService();
